import { IonSpinner } from "@ionic/react";

export const Loading = () => {
    return (
        <IonSpinner name="crescent" />
    );
}